module.exports = __webpack_public_path__ + "img/mi-afwezigheid-huisartsen.f09d59c0.svg";